<template>
  <hic-dialog :visible="visible" @open="openEditor" @close="cancel" :close-on-click-modal="false" width="35.5rem">
    <el-row type="flex" justify="space-between" slot="title">
      <span class="edit-input">{{ !value.id ? "新建" : "编辑" }}字典项：</span>
      <b>{{ value.type | dictText("DictType") }}</b>
      <small class="edit-input"></small>
    </el-row>
    <el-form :model="value" :rules="comRules" ref="editor" label-width="6rem" :disabled="value.disabled">
      <el-form-item v-if="!!value.id" label="编码">
        <el-tag style="width: 100%" hit>
          <b>{{ value.code }}</b>
        </el-tag>
      </el-form-item>
      <el-form-item v-if="value.type == 'DictType'" label="全局" >
        <el-checkbox v-model="value.global"> </el-checkbox>
      </el-form-item>
       <el-form-item v-if="isSelfChain" label="上级" prop="parentCode">
        <hic-dict-selector style="width: 100%" v-model="value.parentCode" :dict-type="value.type" />
      </el-form-item>
      <el-form-item label="名称" prop="text">
        <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.text" @change="genCode" v-hic-select> </el-input>
      </el-form-item>
      <el-form-item v-if="!value.id" label="编码" prop="code">
        <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.code" v-hic-select> </el-input>
      </el-form-item>
      <el-form-item label="助记码" prop="shortCode">
        <el-input class="default-input" size="small" type="text" placeholder="请输入" v-model="value.shortCode" v-hic-select> </el-input>
      </el-form-item>
      <el-form-item label="分类" prop="text" v-if="isChain">
        <hic-dict-selector style="width: 100%" v-model="value.parentCode" :dict-type="dictTypeDict.parentType" />
      </el-form-item>
      <el-form-item label="排序" prop="seqNo">
        <el-input class="default-input" size="small" type="number" placeholder="请输入数字" v-model.number="value.seqNo" v-hic-select> </el-input>
      </el-form-item>

      <slot />

      <el-form-item label="备注" prop="memo">
        <el-input class="default-input" size="small" type="textarea" placeholder="请输入" :row="2" v-model="value.memo"> </el-input>
      </el-form-item>

      <slot name="extra">
        <el-divider>扩展</el-divider>
        <template v-if="value.extraObj && dictTypeDict.extraObj && dictTypeDict.extraObj.type == 'obj'">
          <el-form-item v-for="prop in dictTypeDict.extraObj.props" :key="prop.code" :label="prop.name">
            <el-checkbox v-if="prop.type == 'bool'" v-model="value.extraObj[prop.code]" size="small"></el-checkbox>
            <el-input v-else-if="prop.type == 'num'" v-model.number="value.extraObj[prop.code]" type="number" size="small" v-hic-select></el-input>
            <el-select v-else-if="prop.type == 'dict'" v-model="value.extraObj[prop.code]" :multiple="prop.multiple" filterable style="width: 100%">
              <el-option v-for="o in dict[prop.dict]" :key="o.id" :value="o.code" :label="o.name" />
            </el-select>
            <el-input v-else v-model="value.extraObj[prop.code]" size="small" v-hic-select></el-input>
          </el-form-item>
        </template>

        <el-form-item v-else label="扩展" prop="extra">
          <template v-if="dictTypeDict.extraObj">
            <el-checkbox v-if="dictTypeDict.extraObj.type == 'bool'" v-model="value.extraObj" size="small"></el-checkbox>
            <el-input v-else-if="dictTypeDict.extraObj.type == 'num'" v-model.number="value.extraObj" type="number" size="small" v-hic-select></el-input>
            <el-select v-else-if="dictTypeDict.extraObj.type == 'dict'" v-model="value.extraObj" :multiple="dictTypeDict.extraObj.multiple" filterable style="width: 100%">
              <el-option v-for="o in dict[dictTypeDict.extraObj.dict]" :key="o.id" :value="o.code" :label="o.name" />
            </el-select>
            <el-input v-else v-model="value.extraObj" size="small" v-hic-select></el-input>
          </template>
          <el-input v-else class="default-input" size="small" type="textarea" placeholder="请输入" :row="2" v-model="value.extra" v-hic-select> </el-input>
        </el-form-item>
      </slot>
    </el-form>
    <el-row slot="footer" type="flex" justify="space-between" align="middle">
      <div>
        <el-checkbox v-if="value.id" v-model="value.disabled">停用</el-checkbox>
        <el-tag v-if="value.id && value.disabled" type="danger" :closable="false" class="left-pad">警告：字典项停用后，只能由管理员从数据库恢复！</el-tag>
      </div>
      <div>
        <el-button type="info" @click="cancel">关 闭</el-button>
        <el-button v-if="!value.id" type="primary" @click="save(true)" :disabled="isSaving" :loading="isSaving">保存并新建 </el-button>
        <el-button type="primary" @click="save()" :disabled="isSaving" :loading="isSaving">确 定</el-button>
      </div>
    </el-row>
  </hic-dialog>
</template>
<script>
  import { apiFuns } from "sw-hic";
  let api = {
    Dict: {
      ...apiFuns.genStandard("dict", "/api"),
      copy: (type) => post(`/api/dict/${type}/copy`),
    },
  };
  import { pinyin as py } from "../../";
  import { mapGetters } from "sw-hic";
  export default {
    name: "dict-editor-dialog",
    props: {
      value: {},
      visible: { type: Boolean, default: false },
    },
    data() {
      return {
        loading: false,
        comRules: {
          text: [{ required: true, message: "请输入名称", trigger: "blur" }],
          code: [{ required: true, message: "请输入编码", trigger: "blur" }],
          shortCode: [{ required: true, message: "请输入助记码", trigger: "blur" }],
        },
        isSaving: false,
      };
    },
    computed: {
      ...mapGetters(["dict"]),
      dictTypeDict() {
        if (!this.dict.DictType) {
          return {};
        }
        let typeDict = this.dict.DictType.find((d) => this.value.type == d.code) || {};
        if (typeDict.extra) {
          typeDict.extraObj = JSON.parse(typeDict.extra);
        }
        return typeDict;
      },
      isChain() {
        return this.dictTypeDict.parentType && this.dictTypeDict.parentType != this.dictTypeDict.code;
      },
      isSelfChain() {
        return this.dictTypeDict.parentType == this.dictTypeDict.code;
      },
    },
    methods: {
      openEditor() {
        this.isSaving = false;
        this.isSaving = false;
        if (this.$refs.editor) {
          this.$refs.editor.clearValidate();
        }
        if (this.value.extra) {
          this.$set(this.value, "extraObj", JSON.parse(this.value.extra));
        }
        if (!this.value.extraObj) {
          if (this.dictTypeDict?.extraObj?.type == "obj") {
            this.$set(this.value, "extraObj", {});
          }
        }
      },
      save(autoNext) {
        let _this = this;

        if ((this.isChain || this.isSelfChain) && !this.value.parentType) {
          this.value.parentType = this.dictTypeDict.parentType;
        }
        this.$refs.editor.validate((valid) => {
          if (valid) {
            if (this.value.extraObj) {
              this.value.extra = JSON.stringify(this.value.extraObj);
            }
            _this.isSaving = true;
            api.Dict.save(_this.value)
              .then((res) => {
                if (autoNext) {
                  this.value.id = null;
                  this.value.code = null;
                  this.value.text = null;
                  this.value.shortCode = null;
                  this.value.seqNo = (this.value.seqNo || 0) + 1;
                  this.value.memo = null;
                  this.value.extra = null;
                  this.value.extraObj = {};
                } else {
                  this.value.extraObj = null;
                  this.$emit("update:visible", false);
                }
                _this.$message.success("保存成功！");
                _this.$emit("ok", _this.value);
              })
              .catch((err) => {
                if (err) {
                  _this.$message.error(err.message || err);
                }
              })
              .finally(() => {
                _this.isSaving = false;
              });
          }
        });
      },
      cancel() {
        this.value.extraObj = null;
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      genCode(chns) {
        if (!this.value.id) {
          this.$set(this.value, "code", py.chnToPinYin(chns));
          this.$set(this.value, "shortCode", py.getFirstLetter(this.value.code));
        }
      },
    },
  };
</script>
